import { memo } from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { stripeKey } from "../../../../../../firebase";
import RetryPaymentWStripeFormPaymentForm from "./RetryPaymentWStripeFormPaymentForm";

const stripePromise = loadStripe(stripeKey);
const RetryPaymentWStripeFormElementsProvider = ({
  clientSecret,
}: {
  clientSecret: string;
}) => {
  return (
    <div style={{ height: "100%", width: "100%" }}>
      <Elements
        options={{
          locale: "en-AU",
          clientSecret,
        }}
        stripe={stripePromise}
      >
        <RetryPaymentWStripeFormPaymentForm />
      </Elements>
    </div>
  );
};
export default memo(RetryPaymentWStripeFormElementsProvider);
